import { useMobileShellRegistrar } from "@/react/components/Mobile/hooks/useMobileShellRegistrar";
import { CanvasTopBarRegistrar } from "@/react/components/Mobile/shell/topBar/CanvasTopBarRegistrar";

/**
 * Registers the Canvas/AI shell's title+back row into the mobile shell's
 * pinned TopBar. Pass `false` when there's no active page title crumb, or
 * for pages (e.g. DailyBriefPage) that register their own bar instead via
 * useCircleAiTopBar and deliberately keep their crumb empty on mobile.
 */
export const useCanvasTopBar = (enabled: boolean) =>
  useMobileShellRegistrar(CanvasTopBarRegistrar, enabled ? {} : null);
